import { Model, RailsFormat } from "./model"
import { MatrixClass } from "./matrix-class"
import { Contact } from "./contact"
import { Utilities } from "@helpers/utilities"

export class Enrolment extends Model implements RailsFormat {

  constructor(
    public id?: number,
    public contactId?: number,
    public matrixClassId?: number,
    public cost: number = 0,
    public numberOfClasses: number = 0,
    public startDate: Date = null,
    public transactionDate: Date = null,
    public isCancelling: boolean = false,
    public isPending: boolean = false,
    public isDisenroled: boolean = false,
    public disenrolmentReason: string = null,
    public pendingEnrolment: Enrolment = null,
    public matrixClass: MatrixClass = null,
    public contact: Contact = null,
    public createdAt: Date = null,
    public updatedAt: Date = null,

    public isMenuOpen: boolean = false,
  ) { super() }

  static clone(obj: any) {
    const enrolment: Enrolment = new this()

    if (obj.id) { enrolment.id = obj.id }
    if (obj.contactId) { enrolment.contactId = obj.contactId }
    if (obj.matrixClassId) { enrolment.matrixClassId = obj.matrixClassId }
    if (obj.cost) { enrolment.cost = obj.cost }
    if (obj.numberOfClasses) { enrolment.numberOfClasses = obj.numberOfClasses }
    if (obj.startDate) { enrolment.startDate = Utilities.makeDate(obj.startDate) }
    if (obj.transactionDate) { enrolment.transactionDate = obj.transactionDate }
    if (obj.isCancelling) { enrolment.isCancelling = obj.isCancelling }
    if (obj.isPending) { enrolment.isPending = obj.isPending }
    if (obj.isDisenroled) { enrolment.isDisenroled = obj.isDisenroled }
    if (obj.disenrolmentReason) { enrolment.disenrolmentReason = obj.disenrolmentReason }
    if (obj.pendingEnrolment) { enrolment.pendingEnrolment = Enrolment.clone(obj.pendingEnrolment) }
    if (obj.createdAt) { enrolment.createdAt = Utilities.makeDate(obj.createdAt) }
    if (obj.updatedAt) { enrolment.updatedAt = Utilities.makeDate(obj.updatedAt) }

    if (obj.matrixClass) { enrolment.matrixClass = MatrixClass.clone(obj.matrixClass) }
    if (obj.contact) { enrolment.contact = Contact.clone(obj.contact) }

    return enrolment
  }

  serializeForRails(): any {
    const response: any = Object.assign({}, this) 

    if (this.id === 0) { response.id = null }

    return response
  }

}



// WEBPACK FOOTER //
// /Users/jason/src/matrix/client/src/app/models/enrolment.ts